// ReactDatePicker requires different date format for display,

import { FieldType, TimeFormat } from '../../../utils/apollo/graphqlSchema';

import { DisplayDateFormat } from '../../../utils/formatting';
import { PickEnum } from '../../../utils/types';

// so we need to convert the date format based on the displayDateFormat to
// React-Datepicker format
export const displayDateFormatDictionary: Record<
  DisplayDateFormat,
  Record<
    PickEnum<
      FieldType,
      | FieldType.Date
      | FieldType.Timestamp
      | FieldType.Datetime
      | FieldType.Week
      | FieldType.Month
      | FieldType.Year
    >,
    string
  >
> = {
  'MM/DD/YYYY': {
    [FieldType.Date]: 'MM/dd/yyyy',
    [FieldType.Timestamp]: 'MM/dd/yyyy',
    [FieldType.Datetime]: 'MM/dd/yyyy',
    [FieldType.Week]: 'MM/dd/yyyy',
    [FieldType.Month]: 'MM/yyyy',
    [FieldType.Year]: 'yyyy',
  },
  'DD.MM.YYYY': {
    [FieldType.Date]: 'dd.MM.yyyy',
    [FieldType.Timestamp]: 'dd.MM.yyyy',
    [FieldType.Datetime]: 'dd.MM.yyyy',
    [FieldType.Week]: 'dd.MM.yyyy',
    [FieldType.Month]: 'MM.yyyy',
    [FieldType.Year]: 'yyyy',
  },
  'YYYY-MM-DD': {
    [FieldType.Date]: 'yyyy-MM-dd',
    [FieldType.Timestamp]: 'yyyy-MM-dd',
    [FieldType.Datetime]: 'yyyy-MM-dd',
    [FieldType.Week]: 'yyyy-MM-dd',
    [FieldType.Month]: 'yyyy-MM',
    [FieldType.Year]: 'yyyy',
  },
  'DD/MM/YYYY': {
    [FieldType.Date]: 'dd/MM/yyyy',
    [FieldType.Timestamp]: 'dd/MM/yyyy',
    [FieldType.Datetime]: 'dd/MM/yyyy',
    [FieldType.Week]: 'dd/MM/yyyy',
    [FieldType.Month]: 'MM/yyyy',
    [FieldType.Year]: 'yyyy',
  },
};

/**
 * React-Datepicker format for time based on GlobalFormat.TimeFormat
 */
export const displayTimeFormatDictionary: Record<TimeFormat, string> = {
  [TimeFormat.TwentyFourHour]: 'HH:mm:ss',
  [TimeFormat.TwelveHour]: 'hh:mm:ss a',
};
